"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _icon = _interopRequireDefault(require("../icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuContext = require("./MenuContext");
var _excluded = ["icon", "children", "description", "className", "disabled", "selected", "active", "divider", "prefixCls"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuItem = function MenuItem(props) {
  var icon = props.icon,
    children = props.children,
    description = props.description,
    className = props.className,
    disabled = props.disabled,
    selected = props.selected,
    active = props.active,
    divider = props.divider,
    customPrefixCls = props.prefixCls,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var handleMouseLeave = function handleMouseLeave(e) {
    var _props$onMouseLeave;
    if (disabled) {
      return;
    }
    (_props$onMouseLeave = props.onMouseLeave) === null || _props$onMouseLeave === void 0 || _props$onMouseLeave.call(props, e);
  };
  var handleMouseEnter = function handleMouseEnter(e) {
    var _props$onMouseEnter;
    if (disabled) {
      return;
    }
    (_props$onMouseEnter = props.onMouseEnter) === null || _props$onMouseEnter === void 0 || _props$onMouseEnter.call(props, e);
  };
  var _useContext = (0, _react.useContext)(_MenuContext.MenuContext),
    contextPrefixCls = _useContext.prefixCls;
  var prefixCls = customPrefixCls || contextPrefixCls;
  var handleClick = function handleClick(e) {
    var _props$onClick;
    if (disabled) {
      return;
    }
    (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, e);
  };
  var getFinalClassName = function getFinalClassName() {
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var activeClassName = "".concat(itemPrefixCls, "-focused");
    var selectedClassName = "".concat(itemPrefixCls, "-selected");
    var disabledClassName = "".concat(itemPrefixCls, "-disabled");
    var classes = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, selectedClassName, selected), disabledClassName, disabled), activeClassName, active);
    return (0, _classnames.default)(itemPrefixCls, className, classes);
  };
  var renderIcon = function renderIcon() {
    if ((0, _utils.isString)(icon)) {
      return /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: icon,
        className: "".concat(prefixCls, "-item-custom-icon")
      });
    }
    if ( /*#__PURE__*/_react.default.isValidElement(icon)) {
      return /*#__PURE__*/_react.default.cloneElement(icon, {
        className: (0, _classnames.default)(icon.props.className, "".concat(prefixCls, "-item-custom-icon"))
      });
    }
    return null;
  };
  var renderDescription = function renderDescription() {
    if ((0, _utils.isString)(description) || /*#__PURE__*/_react.default.isValidElement(description)) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(prefixCls, "-item-custom-description")
      }, description);
    }
    return null;
  };
  var renderContent = function renderContent() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(prefixCls, "-item-content")
    }, children);
  };
  if (divider) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "".concat(prefixCls, "-item-divider")
    });
  }
  // @ts-ignore 删除SubMenuProps和MenuItemGroupProps，防止透传到MenuItem DOM上
  var filterProps = (0, _utils.dropProps)(restProps, ['label', 'disabled', 'onTitleClick', 'popClassName', 'popPlacement', 'icon']);
  return /*#__PURE__*/_react.default.createElement("li", _objectSpread(_objectSpread({}, filterProps), {}, {
    className: getFinalClassName(),
    onClick: handleClick,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter
  }), renderIcon(), renderContent(), renderDescription());
};
var _default = exports.default = MenuItem;